import clsx from 'clsx'
import React from 'react'

import { ROW_BG_CLASSES, ROW_BORDER_CLASSES, ROW_FOCUS_CLASSES } from './constants'
import { StickyCellBorder } from './StickyCellBorder'

interface TableCellProps extends Omit<React.TdHTMLAttributes<HTMLTableCellElement>, 'className'> {
  align?: 'left' | 'right' | 'center';
  children: React.ReactNode;
  sticky?: boolean;
}

export function TableCell ({ align = 'left', children, sticky, ...props }: TableCellProps) {
  return (
    <td
      {...props}
      className={clsx(
        ROW_FOCUS_CLASSES,
        ROW_BG_CLASSES,
        ROW_BORDER_CLASSES,
        'py-2 pr-[var(--cell-spacing)] first:pl-[var(--cell-spacing)] body transition',
        {
          sticky,
          'z-10': sticky,
          'text-left': align === 'left',
          'text-right': align === 'right',
          'text-center': align === 'center',
        }
      )}
      data-sticky={sticky}
    >
      {children}
      <StickyCellBorder sticky={sticky} />
    </td>
  )
}

TableCell.displayName = 'Table.Cell'
